import {BreadcrumbType} from 'platform/components';

import {useCreateServiceAccountMutation} from '@dms/api/security';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import {DEFAULT_MAX_TOKEN_LIFETIME} from '../constants/MAX_TOKEN_LIFETIME_OPTIONS';
import {openServiceAccountKeyResultDialog} from '../utils/openServiceAccountKeyResultDialog';
import {ServiceAccountForm, ServiceAccountFormValues} from './ServiceAccountForm';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('entity.serviceAccount.labels.serviceAccounts'),
    href: settingsRoutes.serviceAccountManagement,
  },
];

const defaultValues: ServiceAccountFormValues = {
  name: '',
  description: '',
  email: '',
  maxTokenLifetime: DEFAULT_MAX_TOKEN_LIFETIME,
  roles: [],
  branches: [],
};

export function AddServiceAccount() {
  const navigate = useNavigate();
  const [createServiceAccount] = useCreateServiceAccountMutation();

  const handleSubmit = (values: ServiceAccountFormValues) =>
    createServiceAccount({
      createServiceAccountRequestBody: {
        name: values.name,
        description: values.description || null,
        email: values.email,
        roles: values.roles,
        branches: values.branches,
        maxTokenLifetime: Number(values.maxTokenLifetime),
      },
    })
      .unwrap()
      .then((response) => {
        openServiceAccountKeyResultDialog({
          title: i18n.t('entity.serviceAccount.labels.createdTitle'),
          keyId: response.keyId,
          privateKeyPem: response.privateKeyPem,
          onClose: () =>
            navigate(
              composePath(settingsRoutes.serviceAccountManagementDetail, {
                params: {serviceAccountId: response.id},
              })
            ),
        });
      })
      .catch(handleApiError);

  return (
    <SettingsTemplate
      isCreating
      header={{title: i18n.t('entity.serviceAccount.actions.newServiceAccount'), breadcrumbs}}
      data-testid={testIds.settings.serviceAccountManagementCreate('page')}
    >
      <ServiceAccountForm
        mode="create"
        defaultValues={defaultValues}
        submitButtonTitle={i18n.t('general.actions.create')}
        onSubmit={handleSubmit}
        onCancel={() => navigate(settingsRoutes.serviceAccountManagement)}
        data-testid={testIds.settings.serviceAccountManagementCreate('form')}
      />
    </SettingsTemplate>
  );
}
